import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { OfflineProvider } from './context/OfflineContext';
import LoginPage from './pages/LoginPage';
import LogbookListPage from './pages/LogbookListPage';
import LogbookDetailPage from './pages/LogbookDetailPage';
import UpdateBanner from './components/UpdateBanner';
import './App.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Betöltés...</div>;
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <OfflineProvider>
        <UpdateBanner />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={
                <PrivateRoute>
                  <LogbookListPage />
                </PrivateRoute>
              } />
              <Route path="/logbook/:id" element={
                <PrivateRoute>
                  <LogbookDetailPage />
                </PrivateRoute>
              } />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </BrowserRouter>
      </OfflineProvider>
    </AuthProvider>
  );
}

export default App;